import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=92265f20&"
import script from "./pagination-table.vue?vue&type=script&lang=ts&"
export * from "./pagination-table.vue?vue&type=script&lang=ts&"
import style0 from "./pagination-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports